import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { History } from '../../../features/students/shared/history.model';

@Component({
  selector: 'app-history-student-dialog',
  templateUrl: './history-student-dialog.component.html',
  styleUrls: ['./history-student-dialog.component.scss']
})
export class HistoryStudentDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<HistoryStudentDialogComponent>) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(0);
  }

  getHistoryBySemestre(semestre, historia: History[]) {
    return historia.filter( (historiaItem) => historiaItem.semestre == semestre);
  }
}
